import { createSlice } from "@reduxjs/toolkit"

export const sessionSlice = createSlice({
  name: "sessionSlice",
  initialState: {
    sessionList: [],
    studentList:[],
    exportList: [],
    detail: {},
    totalEntry: 0, 
    isFreshData: false,
  },  
  reducers: {
    setSessionList: (state, action) => {
      state.sessionList = action.payload
    },
    setSessionStudentsList: (state, action) => {
      state.studentList = action.payload
    },
    setFreshList: (state, action) => {
      state.isFreshData = action.payload
    },
    setExportList: (state, action) => {
      state.exportList = action.payload
    },
    setTotalEntry: (state, action) => {
      state.totalEntry = action.payload
    },
    setSingleData: (state, action) => {
      state.detail = action.payload
    }

  }
})

export const {
  setSessionList,
  setSessionStudentsList,
  setFreshList,
  setExportList,
  setSingleData,
  setTotalEntry,
  setFilteredList
} = sessionSlice.actions

export const selectSessionList = (state) => state.session.sessionList
export const selectSessionStudentsList = (state) => state.session.studentList
export const selectFreshList = (state) => state.sport.isFreshData
export const selectExportList = (state) => state.session.exportList
export const selectTotalEntry = (state) => state.session.totalEntry
export const selectSingleDetail = (state) => state.session.detail

export default sessionSlice.reducer
